import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { IoCallOutline, IoLogOutOutline, IoRepeat } from 'react-icons/io5';
import { PiUserCircleFill } from "react-icons/pi";
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { InfoWraper } from './style';
import { oauthRevokeToken, getBizAccountDetails } from '../../actions/api-actions';
import { Popover } from '../cp-popup/cp-popup';
import AvatarImage from '../cp-account-image';
import { getLoginAccountId, getLoginUserEmail } from '../../services/auth-details-service';
import { basePath, gotoLoginPage } from '../../utilities/utility';
import './cp-info.css';
import logger from '../../services/logger';

function AuthInfo({ iconColor }) {
  const [userProfile, setUserProfile] = useState({});
  const userEmailId = getLoginUserEmail();
  const userAccountId = getLoginAccountId();
  const history = useHistory();
  const baseUrl = basePath();
  const dispatch = useDispatch();

  useEffect(() => {
    async function fetchUserProfileData() {
      try {
        const response = await dispatch(getBizAccountDetails(userEmailId));
        if (response?.data?.statusCode === 0) {
          setUserProfile(response?.data?.data);
        }
      } catch (error) {
        // Handle any errors that occur during the user profile data process
        // TODO
      }
    }
    if (userEmailId) fetchUserProfileData();
  }, [userEmailId]);

  const SignOut = async (e) => {
    e.preventDefault();
    try {
      const response = await dispatch(oauthRevokeToken());
      logger.debug(response);
      gotoLoginPage();
    } catch (error) {
      logger.error("LOGOUT ERROR ", error);
      // Handle any errors that occur during the logout process
      // TODO
    }
    //
  };

  const userContent = (
    <div>
      <div className="user_info_dv">
        <div className="user_info">
          <div className="user_avatar_dv">
            {userProfile.iconUrl ? (
              <AvatarImage
                image={userProfile.iconUrl}
                type="IMAGE"
                classValue="user-info-account-profile-image-col"
                sizeVal={40}
              />
            ) : (
              <AvatarImage
                image={userProfile?.name?.slice(0, 1).toUpperCase()}
                classValue="user-info-account-profile-image-col"
                type="AVATAR"
                sizeVal={40}
              />
            )}
          </div>
          <div className="user_details_dv">
            <p className="user_name">{userProfile?.name}</p>
            <p
              className="biz_profile_txt"
              onClick={() => {
                history.push(`${baseUrl}/account/profileinfo/${userAccountId}`);
              }}
            >
              Business profile
            </p>
          </div>
        </div>
        <div className="user_info_link_dv">
          <div
            className="link_dv link_change_business"
            onClick={() => {
              history.push(`${baseUrl}/profile/info`);
            }}
          >
            <IoRepeat className="icon_style_25" /> Change Business
          </div>
          <div
            className="link_dv link_support"
          >
            <IoCallOutline className="icon_style_25" /> Support
          </div>
          <div className="link_dv link_logout" onClick={(e) => SignOut(e)}>
            <IoLogOutOutline className="icon_style_25" /> Sign Out
          </div>
        </div>
      </div>
      {/* <UserDropDwon>
        <div className="user-dropdwon">
          <figure className="user-dropdwon__info">
            {userProfile.iconUrl ? (
              <AvatarImage
                image={userProfile.iconUrl}
                type="IMAGE"
                classValue="user-info-account-profile-image-col"
                sizeVal={40}
              />
            ) : (
              <AvatarImage
                image={userProfile?.name?.slice(0, 1)}
                classValue="user-info-account-profile-image-col"
                type="AVATAR"
                sizeVal={40}
              />
            )}

            <figcaption>
              <Heading as="h5" className="user-info-profile-heading">
                {userProfile?.name}
              </Heading>
              <Link className="user-info-profile-link" to={`${baseUrl}/account/profileinfo/${userAccountId}`}>
                <p>Business profile</p>
              </Link>
            </figcaption>
          </figure>
          <ul className="user-dropdwon__links">
            <li>
              <Link to={`${baseUrl}/profile/info`}>
                <FeatherIcon icon="repeat" /> Change Business
              </Link>
            </li>
            <li>
              <Link to="#">
                <FeatherIcon icon="phone" /> Support
              </Link>
            </li>
          </ul>
          <Link className="user-dropdwon__bottomAction" onClick={SignOut} to="#">
            <FeatherIcon icon="log-out" /> Sign Out
          </Link>
        </div>
      </UserDropDwon> */}
    </div>
  );

  return (
    <InfoWraper>
      <div className="nav-author">
        <Popover placement="bottomRight" content={userContent} action="click">
          <Link to="#" className="head-example">
            {userProfile.iconUrl ? (
              <AvatarImage
                image={userProfile.iconUrl}
                type="IMAGE"
                classValue="account-profile-image-col"
                sizeVal={40}
              />
            ) : (
                <PiUserCircleFill className="header_user_profile_icon" style={{ color: `${iconColor}` }} />
            )} 
          </Link>
        </Popover>
      </div>
    </InfoWraper>
  );
}

AuthInfo.propTypes = {
  iconColor: PropTypes.string,
};

export default AuthInfo;
